
<template>
  <div class="use-table table1">
    <a-table
      :columns="tableHeaderModel"
      :row-selection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange,
        type: 'radio'
      }"
      :rowKey="(record, index) => { return index }"
      bordered
      :pagination="false"
      :data-source="data"
      :scroll="{ x: scrollX, y: 500 }"
      :scrollToFirstRowOnChange="true"
      :loading="loading"
    >

      <template slot="status" slot-scope="text, record">
        <!--          item.isAuth?-->
        <a
          href="javascript:"
          v-for="item in actionBtnGroup"
          v-permission="[item.code]"
          v-show="record.status == item.status || item.btnshow"
          :key="`${item.id}-${item.name}`"
          @click="rowEvent(item.method, text, record)"
        >{{ item.name }}</a>
      </template>

      <template slot="operation" slot-scope="text, record">
        <!--          item.isAuth?-->
        <a
          href="javascript:"
          v-for="item in actionBtnGroup"
          v-if="record.status == item.status || item.btnshow"
          :key="`${item.id}-${item.name}`"
          @click="rowEvent(item.method, text, record)"
        >{{ item.name }}
        </a>
      </template>
<!--      <template slot="operation" slot-scope="text, record">-->
<!--        <a-->
<!--          href="javascript:"-->
<!--          v-for="item in actionBtnGroup"-->
<!--          :key="`${item.id}-${item.name}`"-->
<!--          @click="rowEvent(item.method, text, record, 0)"-->
<!--        >{{ item.name }}-->
<!--        </a>-->
<!--      </template>-->
      <template slot="footer" v-if="isPage">
        <!--      :totals="total"-->
        <use-pagination v-bind="$attrs" v-on="$listeners" />
      </template>
    </a-table>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions } from "vuex";
import UsePagination from "@/components/UsePagination.vue";

export default {
  name: "use-table3",
  components: {
    UsePagination
  },
  props: {
    isPage:{
      type:Boolean,
      default:true
    },
    scrollX: {
      type: String,
      default: "500"
    },
    data: {
      type: Array,
      default: []
    },
    tableHeaderModel: {
      type: Array,
      default: []
    },

  },
  data() {
    return {
      selectedRowKeys:[],
      tableSelectArr:[],

      actionBtnGroup: [],
      // loading:false,
      total: 0,
      tableDataArr: []
    };
  },
  methods: {
    ...mapActions(["getTableSeleted"]),
    // isAuthBtn(){
    //   // 设置操作按钮权限
    //   let userInfo=JSON.parse(sessionStorage.getItem("unInfo"));
    //   if(userInfo.user.superuser!==1&&userInfo.privilege){
    //     let btn=userInfo.privilege.button;
    //     let actionBtnGroup2=this.actionBtnGroup.filter((v,i)=>{
    //       return btn.find(vv=>v.code==vv.code)
    //     })
    //     this.actionBtnGroup=actionBtnGroup2
    //   }
    // },


    onSelectChange(selectedRowKeys, selectedRows) {
      console.log(selectedRowKeys, selectedRows);
      this.selectedRowKeys = selectedRowKeys;
      this.tableSelectArr = selectedRows;
      this.$emit("clickRadioChange",selectedRows);
    },

    rowEvent(method, text, row, num) {
      console.log(method, text, row);
      // let num: any=0;
      // const dataSource = [...this.data];
      // console.log(dataSource);
      // for (let i:any = 0; i < dataSource.length; i++) {
      //   if(row.key==dataSource[i].key){
      //     num=i
      //   }
      // }
      const obj = { method: method, row: row };
      this.$emit("rowEvent", obj);
    },
    //获取选中的table
    filterSelectedTable(selectedRows) {
      const getSelected = [];
      const tableSelectArr = []
      for (const key in selectedRows) {
        getSelected.push(selectedRows[key].id);
        tableSelectArr.push(selectedRows[key])
      }
      console.log(tableSelectArr);
      // this.tableSelectArr=tableSelectArr
      this.getTableSeleted(getSelected);
       this.getTableSeleted(tableSelectArr);
    },
    // 调用清空选中的数据
     clearSelect() {
      this.selectedRowKeys = [];
      this.tableSelectArr = [];
    }
  },
  watch: {
    tableHeaderFileter(val, oldVal) {
      //普通的watch监听
      console.log("a: " + val, oldVal);
      const actionItem = val.find(item => item.title == "操作");
      this.actionBtnGroup = actionItem ? actionItem.btnArr : [];
      // this.isAuthBtn();
    },
    tableData: {
      handler(n, o) {
        console.log(n, "深度监听");
        const { result, size } = n;
        this.tableDataArr = result;
        // this.total = size;
      },
      deep: true
    }
  },

  computed: {
    ...mapGetters({
      tableHeaderFileter: "tableHeaderFileter" // getToDo 不是字符串，对应的是getter里面的一个方法名字 然后将这个方法名字重新取一个别名 todosALise
    }),
    ...mapState(["tableData", "loading"]),
    rowSelection() {
      return {
        onSelect: (record, selected, selectedRows) => {
          console.log(selectedRows, selected, record);
          this.filterSelectedTable(selectedRows);
        },
        onSelectAll: (selected, selectedRows) => {
          console.log(selectedRows, selected);
          this.filterSelectedTable(selectedRows);
        }
      };
    }
  },
  mounted() {
    const rowAction = this.tableHeaderModel.find(item => item.title === "操作");
    if (rowAction) {
      console.log(rowAction.btnArr)
      this.actionBtnGroup = rowAction.btnArr;
    }
  }
};
</script>

<style scoped lang="less">
.use-table {
  /deep/ .ant-table {
    .ant-table-footer {
      text-align: right !important;
    }

    .operation {
      a {
        word-break: keep-all;

        &:not(:last-child) {
          padding-right: 10px;
        }
      }
    }

    .dark-row {
      background-color: #f9f9f9;
    }
  }
}

</style>




<!--<template>-->
<!--  <div class="use-table">-->
<!--    &lt;!&ndash;    :row-selection="rowSelection" 'calc(1000px + 50%)'&ndash;&gt;-->
<!--    <a-table-->
<!--      :columns="tableHeaderFileter"-->
<!--      bordered-->
<!--      :pagination="false"-->
<!--      :data-source="data"-->
<!--      :scroll="{ x: scrollX, y: 500 }"-->
<!--      :scrollToFirstRowOnChange="true"-->
<!--      :loading="loading"-->
<!--    >-->
<!--      <template slot="authorizeStatus" slot-scope="text, record">-->
<!--        &lt;!&ndash;      v-show="(item.method=='handleEdit'&&record.update)||(item.method=='handleDel'&&record.del)||(item.method=='handleDetail')"&ndash;&gt;-->
<!--        &lt;!&ndash;          @click="rowEvent(item.method, text, record,0)"&ndash;&gt;-->
<!--        <a href="javascript:" @click="rowEvent('handleDel', text, record)"-->
<!--          >删除</a-->
<!--        >-->
<!--        <a-->
<!--          href="javascript:"-->
<!--          @click="rowEvent('handleAuth', text, record)"-->
<!--          v-if="record.authorizeStatus == 0"-->
<!--          >授权</a-->
<!--        >-->
<!--        <span v-else>已授权</span>-->
<!--      </template>-->
<!--      <template slot="status" slot-scope="text, record">-->
<!--        &lt;!&ndash;          item.isAuth?&ndash;&gt;-->
<!--        <a-->
<!--          href="javascript:"-->
<!--          v-for="item in actionBtnGroup"-->
<!--          v-if="record.status == item.status || item.btnshow"-->
<!--          :key="`${item.id}-${item.name}`"-->
<!--          @click="rowEvent(item.method, text, record)"-->
<!--          >{{ item.name }}-->
<!--        </a>-->
<!--        &lt;!&ndash;          <span  v-if="record.status==4">异常&nbsp;&nbsp;<a href="javascript:"  @click="rowEvent('handleEdit', text, record,)">编辑</a></span>&ndash;&gt;-->
<!--        &lt;!&ndash;          <span href="javascript:"  v-else-if="record.status==0">已推送</span>&ndash;&gt;-->
<!--        &lt;!&ndash;          <span href="javascript:"  v-else-if="record.status==1">待推送</span>&ndash;&gt;-->
<!--        &lt;!&ndash;          <span href="javascript:"  v-else-if="record.status==2">推送中</span>&ndash;&gt;-->
<!--        &lt;!&ndash;          <span href="javascript:"  v-else-if="record.status==3">推送超时</span>&ndash;&gt;-->
<!--        &lt;!&ndash;          <span v-else-if="record.status==-1"><a href="javascript:"      @click="rowEvent('handletoConfigure', text, record,)">未配置</a></span>&ndash;&gt;-->
<!--      </template>-->
<!--      <template slot="operation" slo
    



// WEBPACK FOOTER //
// src/components/UseTable.vue